// supabaseClient.js — front-end browser Supabase client (ANON key ONLY).
//
// The service-role key is server-side (VPS worker) and MUST NOT appear in the
// bundle. This client uses the publishable anon key, which is safe to ship to the
// browser by design (RLS enforces access).
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
